// MOBILE SLIDER "MOOD"

$("#msdw-slider-mood").slick({
  // infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  //swipe: false,
  prevArrow: "<svg class='msdw-slick-arrow msdw-prev-arrow' xmlns='http://www.w3.org/2000/svg' width='24' height='44'><path d='M21.818 0l2.181 2.183L4.365 21.817l19.634 19.635-2.181 2.182L0 21.817 21.818 0z'/></svg>",
  nextArrow: "<svg class='msdw-slick-arrow msdw-next-arrow' xmlns='http://www.w3.org/2000/svg' width='24' height='44'><path d='M2.18 43.634L0 41.451l19.634-19.634L0 2.182 2.18 0 24 21.817 2.18 43.634z'/></svg>",
  dots: false,
  mobileFirst: true,
  //slide: '.msdw-hotspot-wrapper',
  //initialSlide: 1,
  responsive: [
    {
      // breakpoint: 767,
      breakpoint: 899,
      settings: 'unslick'
    }
  ]
});

$(window).resize(function() {
  $("#msdw-slider-mood").slick("resize");
});

$(window).on("orientationchange", function() {
  $("#msdw-slider-mood").slick("resize");
});


// MOBILE SLIDER PRODUCTS

$("#msdw-slider-products").slick({
  // infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  //swipe: false,
  prevArrow: "<svg class='msdw-slick-arrow-products msdw-prev-arrow-products' xmlns='http://www.w3.org/2000/svg' width='18' height='31'><path d='M4.66 15.479L17.272 2.354 14.917 0 0 15.525 15.224 30.75l2.307-2.4-12.87-12.87z'/></svg>",
  nextArrow: "<svg class='msdw-slick-arrow-products msdw-next-arrow-products' xmlns='http://www.w3.org/2000/svg' width='19' height='31'><path d='M13.482 15.375L.74 28.373l2.33 2.378 15.071-15.376L3.072 0 .74 2.378l12.74 12.997z'/></svg>",
  dots: false,
  mobileFirst: true,
  //slide: '.msdw-hotspot-wrapper',
  //initialSlide: 1,
  responsive: [
    {
      // breakpoint: 767,
      breakpoint: 899,
      settings: {
        slidesToShow: 3
      }
    }
  ]
});

$(window).resize(function() {
  $("#msdw-slider-products").slick("resize");
});

$(window).on("orientationchange", function() {
  $("#msdw-slider-products").slick("resize");
});








$('.jwsdw-imageTile a').attr('target', '_blank');


// MICROMODAL FOR HOTSPOTS
// MicroModal.init();

// $('.modal').appendTo(document.body);
